import React from "react";
import i18n from "../../../constants/i18n";
import { ORDER_PICKER_ENTRIES } from "../../../constants/picker-entries-constants";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getReportsStore from "../../../stores/reports-store";
import Et3Picker from "../../../core/et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../../TypesNEW";

const OrderPicker = withLiteObserverAndTheme<{ notPendingReport: boolean }>(
  (props) => {
    const { notPendingReport } = props;

    return notPendingReport ? (
      <React.Fragment>
        <Et3Margin top={0} bottom={0} right={30} left={0} />
        <Et3Picker
          label={i18n.get("ORDER")}
          options={ORDER_PICKER_ENTRIES}
          onChoose={(value: TEt3PickerSingleValue) => {
            getReportsStore().setOrder(value);
          }}
          value={getReportsStore().order.get()}
          style={{}}
          isMultiple={false}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </React.Fragment>
    ) : null;
  }
);

export default OrderPicker;
